import { render, staticRenderFns } from "./PesquisaBoletimSanitario.vue?vue&type=template&id=60f02b2e&scoped=true&"
import script from "./PesquisaBoletimSanitario.vue?vue&type=script&lang=js&"
export * from "./PesquisaBoletimSanitario.vue?vue&type=script&lang=js&"
import style0 from "./PesquisaBoletimSanitario.vue?vue&type=style&index=0&id=60f02b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f02b2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VOverlay,VPagination,VProgressCircular,VRow,VTextField})
